import { useEffect, useState } from 'react'
import { FormularzPozycji } from '../ekrany/FormularzPozycji.js'
import { IkonaPlus } from './Ikony.js'

/** Czy fokus stoi w polu, w którym „n" ma znaczyć literę, a nie skrót. */
function piszeTekst(): boolean {
  const element = document.activeElement
  if (!(element instanceof HTMLElement)) return false
  if (element.isContentEditable) return true
  return ['INPUT', 'TEXTAREA', 'SELECT'].includes(element.tagName)
}

/**
 * Dodawanie pozycji jest dostępne z każdego ekranu: przyciskiem pod kciukiem
 * na telefonie i klawiszem „N" na pulpicie.
 */
export function DodajPozycje() {
  const [otwarty, ustawOtwarty] = useState(false)

  useEffect(() => {
    const obsluz = (zdarzenie: KeyboardEvent) => {
      if (zdarzenie.key !== 'n' && zdarzenie.key !== 'N') return
      if (zdarzenie.metaKey || zdarzenie.ctrlKey || zdarzenie.altKey) return
      if (piszeTekst()) return
      zdarzenie.preventDefault()
      ustawOtwarty(true)
    }
    document.addEventListener('keydown', obsluz)
    return () => document.removeEventListener('keydown', obsluz)
  }, [])

  return (
    <>
      <button
        type="button"
        className="dodaj-pozycje"
        onClick={() => ustawOtwarty(true)}
        aria-label="Dodaj pozycję"
      >
        <span className="dodaj-pozycje__skrot" aria-hidden="true">
          N
        </span>
        <IkonaPlus width={24} height={24} />
      </button>

      {otwarty ? <FormularzPozycji onZamknij={() => ustawOtwarty(false)} /> : null}
    </>
  )
}
